import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-408d5652"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ub ub-ver ub-as ub-ps flow-log-wrapper" }
const _hoisted_2 = { class: "ub ub-as ub-ps ub-ver flow-log-div" }
const _hoisted_3 = {
  key: 0,
  class: "bottom"
}
const _hoisted_4 = {
  key: 1,
  class: "first"
}
const _hoisted_5 = { class: "ub ub-ver content" }
const _hoisted_6 = { class: "ub ub-ac ub-ps fw confirm-status" }
const _hoisted_7 = { class: "ub ub-ac ub-pc user-name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "left-arrow1" }),
  /*#__PURE__*/_createElementVNode("i", { class: "left-arrow2" })
], -1))
const _hoisted_9 = { class: "ub ub-as fw" }
const _hoisted_10 = { class: "ub ub-as ub-pc confirm-name" }
const _hoisted_11 = { class: "ub ub-ver ub-f1" }
const _hoisted_12 = { class: "ub" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "labelName" }, " 工单状态: ", -1))
const _hoisted_14 = { class: "ub" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "labelName" }, "下一节点:", -1))
const _hoisted_16 = { class: "userName" }
const _hoisted_17 = { class: "time" }
const _hoisted_18 = { class: "ub ub-as ub-ps fw advise" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "labelName" }, "备注: ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isBottom)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.isFirst)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.item.operationTypeStr), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, _toDisplayString((_ctx.item.createName || _ctx.item.operationTenantUserName) ? (_ctx.item.operationTenantUserName || _ctx.item.createName).substr(0, 1) : "客"), 1)
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.item.operationTenantUserName || _ctx.item.createName || "客户"), 1),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_a_space, {
              size: 20,
              class: "ub ub-pb"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("span", null, _toDisplayString(_ctx.item.operationTypeStr), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.item.nextNodeUserName), 1)
                ]),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.item.createTime), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_space, {
              size: 20,
              class: "ub ub-pb"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createTextVNode(" " + _toDisplayString(_ctx.item.remark), 1)
                ]),
                _hoisted_20
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}